module.exports = __webpack_public_path__ + "media/images/clearbanc-glyph-ffe283775b90ddc0cec4479e717d474c.svg";